// 우편번호 API 설정 섹션 URL (2026-08-10 KST 추가)
const postcodeSettingsSection = "/postcode-settings";

export const postcodeSettingsPath = postcodeSettingsSection;
